<template>
    <v-row>


        <v-col cols="12" sm="6" md="6">
            <MetaReelsBanner />
        </v-col>

        <v-col cols="12" sm="6" md="6">
            <YoutubeShortsBanner />
        </v-col>


    </v-row>
</template>



<script setup>

import MetaReelsBanner from './Meta-Reels-Banner.vue';
import YoutubeShortsBanner from './Youtube-Shorts-Banner.vue';

</script>